// extracted by mini-css-extract-plugin
export default {"hero":"HeroSection_hero__WcPgA","image":"HeroSection_image__y47yM","about":"HeroSection_about__s3-26"};